module.exports = __webpack_public_path__ + "static/media/barcode-scan.3df43680.svg";